export default {
  'pages.repository.section.basic': 'Basic information',
  'pages.repository.section.gitlab': 'GitLab synchronization',
  'pages.repository.section.permissions': 'Member permissions',
  'pages.repository.create.success': 'Repository created',
  'pages.repository.create.failed': 'Failed to create repository',
  'pages.repository.update.success': 'Repository updated',
  'pages.repository.update.failed': 'Failed to update repository',
  'pages.repository.gitlab.sync': 'Sync to GitLab',
  'pages.repository.gitlab.sync.description':
    'Creates a GitLab group named after the project identifier first, then creates the repository inside it. The repository URL is managed automatically.',
  'pages.repository.gitlab.retrySync': 'Retry GitLab synchronization',
  'pages.repository.gitlab.retrySync.description':
    'This repository is not linked to a GitLab project. Enable this and save to recreate or link the project group and repository.',
  'pages.repository.gitlab.creationOrder.title': 'GitLab creation path',
  'pages.repository.gitlab.creationOrder.description':
    'On save: create the project group (name and path use the project identifier), then create the repository (path uses the repository identifier).',
  'pages.repository.gitlab.editPermissions.title':
    'Manage GitLab repository member permissions',
  'pages.repository.gitlab.editPermissions.description':
    'Saving updates members managed by Super Software Factory. Members added from other GitLab sources are not removed.',
  'pages.repository.gitlab.pendingIdentifier': 'Identifier pending',
  'pages.repository.gitlab.memberPermissions.title': 'Repository members',
  'pages.repository.gitlab.memberPermissions.managedOnly':
    'SSF-managed members only',
  'pages.repository.gitlab.memberPermissions.description':
    'Assign repository access to active project members. Suggested access is based on project roles and can be adjusted per repository.',
  'pages.repository.gitlab.memberPermissions.empty':
    'No repository members assigned',
  'pages.repository.gitlab.memberPermissions.noProjectMembers':
    'No active project members are available. Add members in Project Settings first.',
  'pages.repository.gitlab.memberPermissions.loadFailed':
    'GitLab permissions could not be loaded. Saving is disabled until they are reloaded to prevent accidental member removal.',
  'pages.repository.gitlab.memberPermissions.loadUnavailable':
    'Permission data has not loaded successfully and is not being treated as an empty list. Reload before editing.',
  'pages.repository.gitlab.memberPermissions.retry': 'Reload',
  'pages.repository.gitlab.memberPermissions.tab': 'GitLab permissions',
  'pages.repository.gitlab.memberPermissions.save': 'Save permissions',
  'pages.repository.gitlab.memberPermissions.saveSuccess':
    'GitLab permissions saved',
  'pages.repository.gitlab.memberPermissions.saveFailed':
    'Failed to save GitLab permissions',
  'pages.repository.gitlab.memberPermissions.consistencyWarning':
    'The displayed records may not match the effective GitLab permissions',
  'pages.repository.gitlab.memberPermissions.consistencyWarning.description':
    'Check the GitLab username and requested access for failed members, then save again to retry synchronization.',
  'pages.repository.gitlab.memberPermissions.syncStatus': 'Sync status:',
  'pages.repository.gitlab.memberPermissions.syncStatus.synced': 'Synced',
  'pages.repository.gitlab.memberPermissions.syncStatus.pending': 'Pending',
  'pages.repository.gitlab.memberPermissions.syncStatus.unmapped':
    'GitLab user not matched',
  'pages.repository.gitlab.memberPermissions.syncStatus.failed':
    'Synchronization failed',
  'pages.repository.gitlab.memberPermissions.syncStatus.notSynced':
    'Not synchronized',
  'pages.repository.gitlab.memberPermissions.syncError':
    'Failure reason: {error}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel':
    'Effective GitLab access: {accessLevel}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel.unknown':
    'Not confirmed',
  'pages.repository.gitlab.memberPermissions.inheritedAccess':
    'This member inherits access from a parent GitLab group. Repository-level settings cannot downgrade or revoke it.',
  'pages.repository.gitlab.member': 'Project member',
  'pages.repository.gitlab.member.required': 'Select a project member',
  'pages.repository.gitlab.member.duplicate':
    'A member cannot be assigned more than once',
  'pages.repository.gitlab.member.placeholder': 'Select a project member',
  'pages.repository.gitlab.member.add': 'Add member permission',
  'pages.repository.gitlab.member.remove': 'Remove member permission',
  'pages.repository.gitlab.accessLevel': 'GitLab access',
  'pages.repository.gitlab.accessLevel.required': 'Select GitLab access',
  'pages.repository.gitlab.accessLevel.10': 'Guest',
  'pages.repository.gitlab.accessLevel.20': 'Reporter',
  'pages.repository.gitlab.accessLevel.30': 'Developer',
  'pages.repository.gitlab.accessLevel.40': 'Maintainer',
  'pages.repository.gitlab.projectContext.loadFailed':
    'The project identifier or members could not be loaded. GitLab permission settings may be incomplete.',
  'pages.repository.gitlab.memberSync.unknownError': 'Unknown reason',
  'pages.repository.gitlab.memberSync.partialFailure':
    'Failed to synchronize permissions for {count} member(s): {details}',
  'pages.repository.gitlab.memberSync.inheritedAccess':
    '{count} member(s) still inherit access from a parent GitLab group, which repository-level settings cannot downgrade or revoke: {members}',
  'pages.repository.gitlab.sync.alreadyExists':
    'A matching GitLab repository already exists and has been linked',
  'pages.repository.gitlab.sync.success':
    'Synchronized to GitLab project group {groupPath}',
  'pages.repository.gitlab.sync.incomplete':
    'GitLab synchronization was not completed: {reason}',
  'pages.repository.gitlab.sync.createFailed':
    'The local repository was created, but GitLab synchronization failed. Edit the repository to retry.',
};
